<template lang="pug">
.contact_us
  banner(:background="bannerImage", :title="title")
  .py-5.bg_light
    .container
      .row.justify-content-center.py-5
        .col-md-8
          form.p-4.bg-white
            h4.mb-4 {{ tableTitle }}
            .form-row
              .form-group.col-md-6
                input.form-control.rounded-0(
                  v-model="firstName",
                  type="text",
                  placeholder="First name",
                  :class="{ 'is-invalid': firstNameStatus }"
                )
              .form-group.col-md-6
                input.form-control.rounded-0(
                  v-model="lastName",
                  type="text",
                  placeholder="Last name",
                  :class="{ 'is-invalid': lastNameStatus }"
                )
            .form-row
              .form-group.col-md-6
                input.form-control.rounded-0(
                  v-model="email",
                  type="text",
                  placeholder="E-mail",
                  :class="{ 'is-invalid': emailStatus }"
                )
              .form-group.col-md-6
                select#LocationSelect.form-control.rounded-0(
                  v-model="location",
                  :class="{ 'is-invalid': locationStatus }"
                )
                  option(value="") Location
                  option(
                    :value="country",
                    v-for="(country, index) in countryList"
                  ) {{ country.name }}
            .form-row
              .form-group.col-md-12
                select#LocationSelect.form-control.rounded-0(
                  v-model="requestConcerns",
                  :class="{ 'is-invalid': requestConcernsStatus }"
                )
                  option(value="") Your Request concerns?
                  option(
                    :value="concern",
                    v-for="(concern, index) in contactUsList"
                  ) {{ concern.title }}
            .form-group
              textarea#exampleFormControlTextarea1.form-control.rounded-0(
                v-model="message",
                placeholder="Messege",
                rows="3",
                :class="{ 'is-invalid': messageStatus }"
              )
            .form-row.align-items-center
              .form-group.col-md-7
                .custom-control.custom-checkbox.mr-sm-2
                  input#customControlAutosizing1.custom-control-input(
                    v-model="copyEmailToAddress",
                    type="checkbox"
                  )
                  label.custom-control-label(for="customControlAutosizing1") Receive a copy of this email to your address.
                .custom-control.custom-checkbox.mr-sm-2
                  input#customControlAutosizing2.custom-control-input(
                    v-model="termsConditionsCheck",
                    type="checkbox"
                  )
                  label.custom-control-label(for="customControlAutosizing2")
                    | Accept &nbsp
                    a(
                      v-b-modal.modal-scrollable="",
                      @click="showTextDialog(0)"
                    ) Terms &amp; Conditions
                    |
                    | of Use.
                .custom-control.custom-checkbox.mr-sm-2
                  input#customControlAutosizing3.custom-control-input(
                    v-model="privacyPollicyCheck",
                    type="checkbox"
                  )
                  label.custom-control-label(for="customControlAutosizing3")
                    | By registering you agree to our &nbsp
                    a(
                      v-b-modal.modal-scrollable="",
                      @click="showTextDialog(1)"
                    ) Privacy Policy
                    | .
              .form-group.col-md-5
            a.btn.btn-primary.rounded-0.btn-block(
              v-b-modal.modal-scrollable="",
              data-toggle="modal",
              data-target="#contactModal",
              @click="submitData"
            ) Submit

  float-actions
  float-top
  .PCAP-IC-selector.d-block.d-sm-none
    a.shadow-sm(
      v-b-modal.dialog="",
      @click="$bvModal.show('selectorModal')",
      data-toggle="modal",
      data-target="#selectorModal"
    )
      font-awesome-icon.i_mr_1(:icon="['fas', 'search']") 
      | PCAP IC selector
  custom-footer
  dialog-text(:title="dialogTitle", :divider="false", :contentCenter="false")
    template(#content) 
      p(style="margin: 0")
        small(v-html="dialogContent")
  dialog-update-notice(
    :termsConditionsCheck="termsConditionsCheck",
    @showTermsCondition="showTextDialog(0)"
  )
</template>

<script>
import Banner from "@/components/news_detail/Banner";
import Footer from "@/components/home/Footer";
import FloatTop from "@/components/common/FloatTop";
import FloatActions from "@/components/common/FloatActions";
import DialogText from "@/components/common/DialogText";
import DialogUpdateNotice from "@/components/common/DialogUpdateNotice";
import Vue from "vue";
import { VueReCaptcha } from "vue-recaptcha-v3";
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY });
import { validEmail, validStringEmpty } from "@/utils/validate";
import { getCountryList } from "@/api/location";
import {
  getContactUsInformation,
  getContactUsList,
  contactUs,
} from "@/api/contact_us";

export default {
  name: "ContactUs",
  metaInfo() {
    return {
      title: this.metaData.title,
    };
  },
  components: {
    Banner,
    "custom-footer": Footer,
    FloatTop,
    FloatActions,
    DialogText,
    DialogUpdateNotice,
  },
  data() {
    return {
      title: "Contact US",
      bannerImage: "",
      tableTitle: "",

      dialogTitle: "",
      dialogContent: "",
      dialogTexts: [
        {
          title: "Terms & Conditions",
          content: "",
        },
        {
          title: "Privacy Policy",
          content: "",
        },
      ],

      copyEmailToAddress: false,
      termsConditionsCheck: false,
      privacyPollicyCheck: false,

      countryList: [],
      contactUsList: [],

      firstName: "",
      lastName: "",
      email: "",
      location: "",
      requestConcerns: "",
      message: "",

      firstNameStatus: false,
      lastNameStatus: false,
      emailStatus: false,
      locationStatus: false,
      requestConcernsStatus: false,
      messageStatus: false,

      metaData: {
        title: "Contact us ｜EETI – Empower TouchSystem",
      },
    };
  },
  watch: {
    "$store.state.user.language"() {
      this.initialLanguage();
    },
  },
  created() {
    this.initialLanguage();
  },
  methods: {
    initialLanguage() {
      this.getCountryList();
      this.getContactUsList();
      this.getContactUsInformation();
    },
    getContactUsInformation() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getContactUsInformation(temp).then((response) => {
        this.title = response.data.title;
        this.tableTitle = response.data.table_title;
        this.bannerImage = response.data.photo ? response.data.photo.image : "";
        this.dialogTexts[0].content = response.data.terms_condition;
        this.dialogTexts[1].content = response.data.privacy_policy;
      });
    },
    getCountryList() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getCountryList(temp).then((response) => {
        this.countryList = response.data;
      });
    },
    getContactUsList() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getContactUsList(temp).then((response) => {
        this.contactUsList = response.data;

        if (
          this.$route.params.category != undefined &&
          this.$route.params.category != ""
        ) {
          for (let index in this.contactUsList) {
            let temp = this.contactUsList[index];
            if (temp.id == this.$route.params.category) {
              this.requestConcerns = temp;
            }
          }
        } else {
          this.requestConcerns = "";
        }
      });
    },
    submitData() {
      if (this.checkData()) {
        if (!this.termsConditionsCheck || !this.privacyPollicyCheck) {
          alert("please check Terms Conditions & Privacy Policy");
        } else {
          this.$recaptcha("contactUs").then((token) => {
            let inputData = {
              first_name: this.firstName,
              last_name: this.lastName,
              email: this.email,
              country: this.location.id,
              category: this.requestConcerns.id,
              message: this.message,
              is_copy_email_to_address: this.copyEmailToAddress,
              recaptcha_token: token,
            };
            contactUs(inputData)
              .then(() => {
                alert("send data success!");
                this.$router.push({
                  name: "Home",
                });
              })
              .catch((error) => {
                alert(error.response.data.error);
              });
          });
        }
      }
    },
    checkData() {
      if (validStringEmpty(this.firstName)) {
        this.firstNameStatus = true;
      } else {
        this.firstNameStatus = false;
      }
      if (validStringEmpty(this.lastName)) {
        this.lastNameStatus = true;
      } else {
        this.lastNameStatus = false;
      }
      if (validEmail(this.email)) {
        this.emailStatus = false;
      } else {
        this.emailStatus = true;
      }
      if (this.location == "") {
        this.locationStatus = true;
      } else {
        this.locationStatus = false;
      }
      if (this.requestConcerns == "") {
        this.requestConcernsStatus = true;
      } else {
        this.requestConcernsStatus = false;
      }
      if (validStringEmpty(this.message)) {
        this.messageStatus = true;
      } else {
        this.messageStatus = false;
      }

      if (
        this.firstNameStatus ||
        this.lastNameStatus ||
        this.emailStatus ||
        this.locationStatus ||
        this.requestConcernsStatus ||
        this.messageStatus
      ) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
        return false;
      } else {
        return true;
      }
    },
    showTextDialog(type) {
      this.dialogTitle = this.dialogTexts[type].title;
      this.dialogContent = this.dialogTexts[type].content;
      this.$bvModal.show("textModal");
    },
    showUpdateNoticeDialog() {
      this.$bvModal.show("updateNoticeModal");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/contact_us/contact_us";
</style>
